<script lang="ts" setup>
import { computed } from 'vue'
import CircularProgress from '@/uiKit/CircularProgress.vue'

const props = defineProps<{
  resourceName: string
  limit: number
  usage: number
}>()

const formattedRatio = computed(
  () => `${props.usage.toLocaleString()} of ${props.limit.toLocaleString()}`,
)
const usedPercentage = computed(() => Math.min((props.usage / props.limit) * 100, 100))
</script>

<template>
  <div class="usage">
    <div class="usage__meter">
      <CircularProgress :percentage="usedPercentage" />
    </div>
    <div class="usage__title">{{ resourceName }}</div>
    <div class="usage__value value">
      <span class="value__amount">{{ formattedRatio }}</span>
      <span class="value__descriptor">{{
        resourceName === 'Files' || resourceName === 'Storage' ? 'uploaded' : 'used'
      }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.usage {
  display: grid;
  grid-template-columns: auto 2fr 3fr auto;
  padding: var(--size-2);
  gap: var(--size-2);
  position: relative;

  @include typographyRegularBody100;

  &__meter {
    width: 16px;
    height: 16px;
    background: var(--color-primary-default);
    border-radius: 100px;
  }

  &:not(:last-child):after {
    content: '';
    position: absolute;
    left: 24px;
    right: 0;
    bottom: 0;
    border-bottom: 1px solid var(--color-border-subtle);
  }
}

.value {
  display: inline-flex;
  gap: var(--size-1);
  flex-direction: row;
  justify-self: flex-end;

  &__descriptor {
    color: var(--color-text-subtlest);
  }
}
</style>
